export const checkCurrentPageURL = (): { isMen: boolean, isWomen: boolean } => {
  const url: string = window.location.href;
  const isMen: boolean = /\bmen\b|\bmens\b/i.test(url);
  const isWomen: boolean = /\bwomen\b|\bwomens\b/i.test(url);
  
  return { isMen, isWomen };
}